import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { ServicesSection } from '../components/sections/ServicesSection';
import { SEOHead } from '../components/SEOHead';

export const ServicesPage: React.FC = () => {
  return (
    <div className="App font-arabic">
      <SEOHead 
        title="خدمات ضوء الخريج - اكتشف وقارن واختر تخصصك المثالي"
        description="تعرف على جميع خدمات ضوء الخريج: استكشاف +2000 برنامج تعليمي، مقارنة التخصصات، حاسبة النسبة الموزونة، استشارات اسأل خريج، والمرشد الذكي."
        keywords="خدمات ضوء الخريج, استكشاف التخصصات, مقارنة التخصصات, حاسبة النسبة الموزونة, اسأل خريج, استشارات مهنية, المرشد الذكي"
        canonical="https://about.alkhreej.com/services"
      />
      
      {/* Fixed Header */}
      <Header />
      
      {/* Main Content */}
      <main className="relative pt-20">
        {/* Services Section */}
        <ServicesSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};